import {
  Component,
  ComponentInterface,
  getAssetPath,
  h,
  Prop,
  State,
} from "@stencil/core";
import { IThemeOptions } from "../../../models";
import { ThemeService } from "../../../services";

@Component({
  tag: "av-asset",
  shadow: false,
  styleUrl: "av-asset.scss",
  assetsDirs: ["auvious-assets"],
})
export class AvAsset implements ComponentInterface {
  @Prop() image;
  @Prop() color: "light" | "dark" | "theme";

  @State() themeOptions: IThemeOptions;

  constructor() {
    ThemeService.optionsAvailable().subscribe((o) => (this.themeOptions = o));
  }

  render() {
    const postfix =
      this.color === "theme"
        ? this.themeOptions.darkMode
          ? "light"
          : "dark"
        : !this.color
        ? "light"
        : this.color;

    const fileName = `${this.image}-${postfix}.svg`;

    const src =
      this.themeOptions.assetPath &&
      this.themeOptions.assets.includes(this.image)
        ? [this.themeOptions.assetPath, fileName].join("/")
        : getAssetPath(`./auvious-assets/${fileName}`);

    return (
      <img
        aria-hidden="true"
        style={{ width: "100%" }}
        part="av-asset-img"
        src={src}
      />
    );
  }
}
